import ForwardIcon from '@mui/icons-material/Forward'
import {useMediaQuery} from '@mui/material'
import {Splide, SplideSlide} from '@splidejs/react-splide'
import '@splidejs/react-splide/css'
import {envBackHost} from 'GLOBAL/envVariables'
import {defaultImage} from 'assets/imageDeclear'
import dayjs from 'dayjs'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import _ from 'lodash'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import FreezeImg from './FrozenWarning.png'
import GrandParent from './gradParent.png'
import InstallImg from './installImg.png'
import LeakImg from './leakImage.jpg'

type SlideCardProps = {
  id?: any
  title?: string
  themeColor?: 'green' | 'red' | 'yellow' | 'blue' | 'default'
  image?: any
  listName?: any
  listCount?: any
  link?: any
}

const SlideCard = ({
  id = 'default',
  title = 'title',
  themeColor = 'default',
  image = defaultImage,
  listName = ' ',
  listCount,
  link = '/',
}: SlideCardProps) => {
  const color = {
    green: {
      border: 'border-green-600',
      text: 'text-green-600',
      backGround: 'bg-green-600',
      hoverBackGround: 'hover:bg-green-700',
    },
    red: {
      border: 'border-red-600',
      text: 'text-red-600',
      backGround: 'bg-red-600',
      hoverBackGround: 'hover:bg-red-700',
    },
    yellow: {
      border: 'border-yellow-500',
      text: 'text-yellow-500',
      backGround: 'bg-yellow-600',
      hoverBackGround: 'hover:bg-yellow-700',
    },
    blue: {
      border: 'border-blue-500',
      text: 'text-blue-500',
      backGround: 'bg-blue-500',
      hoverBackGround: 'hover:bg-blue-600',
    },
    default: {
      border: 'border',
      text: 'text-black',
      backGround: 'bg-slate-700',
      hoverBackGround: 'hover:bg-slate-800',
    },
  }

  return (
    <SplideSlide id={id}>
      <div
        className={`bg-white align-items-stretch border-[2px] ${color[themeColor]?.border} rounded-xl flex flex-col p-2 py-3`}
      >
        <div className={'d-flex justify-content-between align-items-center'}>
          <span className={`${color[themeColor]?.text} fs-3 fw-bold`}>{title}</span>
          <span className={'text-muted fw-bold'}>{dayjs().format('YYYY-MM-DD')} 기준</span>
        </div>
        <div className='flex justify-center items-center h-[7.5rem] aspect-square'>
          <img src={image} alt={id} className='max-h-full max-w-full object-contain' />
        </div>
        <div className={'row px-6 fs-4 fw-bold'}>
          <div className={'d-flex justify-content-around'}>
            <span className='inline-block max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap'>
              {listName}
              {listCount == null ? ` 조회 중` : ` ( ${listCount}건 )`}
            </span>
          </div>
          <div className={'text-center mt-2 justify-center flex'}>
            <Link to={link}>
              <button
                className={`flex items-center justify-center gap-1 ${color[themeColor]?.backGround} ${color[themeColor]?.hoverBackGround} text-white text-sm font-medium px-3 py-1 rounded`}
              >
                바로가기
                <ForwardIcon className='w-4 h-4' />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </SplideSlide>
  )
}

const AsideStatusCard = () => {
  const cooperInfo = useSelector((state: any) => state.cooperInfo)
  const officeInfo = useSelector((state: any) => state.officeInfo)
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  const isMobile = useMediaQuery('(max-width: 991px)')
  const canViewStatusCard =
    !isMobile &&
    (userInfo?.accountType?.includes('sys') ||
      userInfo?.accountType?.includes('admin') ||
      userInfo?.accountType?.includes('charge'))
  const [filter, setFilter] = useState<any>({
    searchOption: {
      customerNumber: false,
      customerName: false,
      managerName: false,
      address: false,
      memo: false,
    },
    searchData: '',
    date: dayjs().format('YYYYMMDD'),
  })
  const [leakFilter, setLeakFilter] = useState<any>({
    searchOption: {
      customerNumber: false,
      customerName: false,
      address: false,
    },
    searchData: '',
    date: dayjs().format('YYYYMMDD'),
  })
  const [customerInfoFilter, setCustomerInfoFilter] = useState<any>({
    searchOption: {
      customerNumber: false,
      customerName: false,
      address: false,
      managerName: false,
      memo: false,
      serialNumber: false,
      installerName: false,
    },
    searchData: '',
    deviceStatus: 'all',
    efosStatus: 'all',
    deviceType: 'all',
    batteryStatus: 'all',
    rowPerPage: 30,
    page: 1,
  })
  const [monitoringList, setMonitoringList] = useState<any>(null)
  const [leakList, setLeakList] = useState<any>(null)
  const [leakLoading, setLeakLoading] = useState<any>(false)
  const [customerInfoCount, setCustomerInfoCount] = useState<any>(null)
  const [freezeCount, setFreezeCount] = useState<any>(0)
  const getCustomerInfo = () => {
    axiosWithAuth()
      .get(
        `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
          cooperInfo?.value
        }/customer/info`,
        {
          params: customerInfoFilter,
        }
      )
      .then((res) => {
        setCustomerInfoCount(res.data.count)
      })
  }
  const getMonitoringList = () => {
    axiosWithAuth()
      .get(
        `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
          cooperInfo?.value
        }/customer/monitoring`,
        {
          params: filter,
        }
      )
      .then((res) => {
        setMonitoringList(res.data.res)
      })
  }

  const getLeakInfos = () => {
    if (officeInfo?.value !== 'yit') {
      setLeakLoading(true)
      axiosWithAuth()
        .get(
          `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
            cooperInfo?.value
          }/dashboard/leakandlongtermcount`,
          {
            params: filter,
          }
        )
        .then(async (res) => {
          setLeakLoading(false)
          if (res && userInfo?.userId) {
            setLeakList(res?.data?.res?.[0] ?? {})
          }
        })
    }
  }

  const getFrozenStatus = () => {
    axiosWithAuth()
      .get(
        `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
          cooperInfo?.value
        }/dashboard/freezewarningcount`
      )
      .then((res) => {
        let count = 0
        _.map(res.data.res, (el, idx) => {
          if (el.freezeWarningTypeName !== '양호') {
            count = count + el.freezeWarningCount
          }
        })

        setFreezeCount(count)
      })
  }

  useEffect(() => {
    if (!canViewStatusCard) return
    getFrozenStatus()
    getMonitoringList()
    getCustomerInfo()
    getLeakInfos()
  }, [officeInfo, cooperInfo, canViewStatusCard])

  return (
    <>
      {canViewStatusCard && (
        <div className={'row gap-3 px-0 mx-0'}>
          <Splide
            options={{
              type: 'loop',
              autoplay: true,
              speed: 600,
              interval: 5000,
              height: 240,
            }}
          >
            {officeInfo?.value !== 'yit' && (
              <>
                <SlideCard
                  id='leak'
                  title='누수 의심현황'
                  themeColor='red'
                  image={LeakImg}
                  listName='누수 의심'
                  listCount={leakList?.count}
                  link={'/customer/customer-leakage'}
                />
              </>
            )}

            <SlideCard
              id='monitoring'
              title='건강모니터링'
              themeColor='green'
              image={GrandParent}
              listName='모니터링'
              listCount={monitoringList?.count}
              link={'/customer/activity'}
            />

            <SlideCard
              id='install'
              title='설치현황'
              themeColor='yellow'
              image={InstallImg}
              listName={officeInfo?.label}
              listCount={customerInfoCount}
              link={
                userInfo?.accountType?.includes('sys')
                  ? '/customer/info'
                  : '/customer/customer-status'
              }
            />
            <SlideCard
              id='freeze'
              title='동파위험'
              themeColor='blue'
              image={FreezeImg}
              listName='동파위험'
              listCount={freezeCount}
              link={'/customer/freeze-warning'}
            />
          </Splide>
        </div>
      )}
    </>
  )
}

export default AsideStatusCard
